import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Modal } from 'semantic-ui-react';
import { EstateUnit } from '../../../types/EstateUnit';

type DeactivateUnitConfirmModalProps = {
  open: boolean;
  unit: EstateUnit | null;
  isSubmitting?: boolean;
  onClose: () => void;
  onConfirm: (unlinkUsers: boolean) => void;
};

const DeactivateUnitConfirmModal: React.FC<DeactivateUnitConfirmModalProps> = ({
  open,
  unit,
  isSubmitting = false,
  onClose,
  onConfirm
}) => {
  const [unlinkUsers, setUnlinkUsers] = useState(true);

  useEffect(() => {
    if (open) {
      setUnlinkUsers(true);
    }
  }, [open, unit?.id]);

  return (
    <Modal open={open} onClose={onClose} size="small">
      <Modal.Header>Inativar unidade</Modal.Header>
      <Modal.Content>
        <p>
          Deseja inativar a unidade &quot;{unit?.name}&quot;?
        </p>
        <Checkbox
          checked={unlinkUsers}
          label="Desvincular todos usuários dessa unidade."
          onChange={(_, { checked }) => setUnlinkUsers(Boolean(checked))}
        />
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onClose} disabled={isSubmitting}>
          Cancelar
        </Button>
        <Button
          color="red"
          onClick={() => onConfirm(unlinkUsers)}
          loading={isSubmitting}
          disabled={isSubmitting}
        >
          Confirmar
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default DeactivateUnitConfirmModal;
